module.exports = __webpack_public_path__ + "img/register-header.b4940ba3.svg";